import { ReportFeatures } from '@hcs/types';

export const REPORT_INTRA_ORG_LINK_FEATURES = [ReportFeatures.IntraOrgLinks];
